import * as React from "react";

function ConectaZapErrorIcon(props) {
  return (
    <svg
      width={41}
      height={41}
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x={0.25}
        y={0.318848}
        width={40}
        height={40}
        rx={20}
        fill="#C62828"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.543 11.612a1 1 0 011.414 0l7.293 7.293 7.293-7.293a1 1 0 011.414 1.414l-7.293 7.293 7.293 7.293a1 1 0 01-1.414 1.414l-7.293-7.293-7.293 7.293a1 1 0 01-1.414-1.414l7.293-7.293-7.293-7.293a1 1 0 010-1.414z"
        fill="#fff"
      />
    </svg>
  );
}

export default ConectaZapErrorIcon;
